import * as ShareableLinkErrors from '../../errors/shareableLink';
import statuses from '../../components/CreateShareableLink/statuses';
import * as Error from '../../utils/error';
import bop, { transform } from '../../../../bop';

export function generateLink(groupId, currentCollaboratorId) {
    const payload = { groupId, currentCollaboratorId };

    return Promise.resolve().then(() => {
        if (!(groupId && currentCollaboratorId)) {
            throw Error.create(
                'Payload is falsy',
                ShareableLinkErrors.SHAREABLE_LINK_CREATEEABLE_FALSY_PAYLOAD,
                payload
            );
        }
    }).then(() => {
        const url = `/collaboration/groups/links?group_id=${groupId}&current_collaborator_identifier=${currentCollaboratorId}`;
        return bop.post(url)
            .after({ transformBody: transform.toCamelCase, statusCode: 201 })
            .run();
    }).then((data) => {
        const link = Object.values(data.shareableLinks)[0];

        if (!link) {
            throw Error.create(
                'invalid response structure',
                ShareableLinkErrors.SHAREABLE_LINK_CREATE_INVALID_RESPONSE_STRUCTURE,
                { payload, data }
            );
        }

        return link;
    }).catch((error) => {
        if (!error.code) {
            error.code = ShareableLinkErrors.SHAREABLE_LINK_CREATE_BAD_SERVER_UNEXPECTED;
            error.details = { payload: JSON.stringify(payload) };
        }

        throw error;
    });
}

export function setLinkStatus(linkId, status) {
    const payload = { linkId, status };
    return Promise.resolve()
        .then(() => {
            if (!status) {
                throw Error.create(
                    'status is falsy',
                    ShareableLinkErrors.SHAREABLE_LINK_SET_STATUS_FALSY_STATUS,
                    { status }
                );
            }
            if (status !== statuses.ACTIVE && status !== statuses.SUSPENDED) {
                throw Error.create(
                    'status is invalid',
                    ShareableLinkErrors.SHAREABLE_LINK_SET_STATUS_INVALID_STATUS,
                    { status }
                );
            }
            if (!linkId) {
                throw Error.create(
                    'falsy linkId',
                    ShareableLinkErrors.SHAREABLE_LINK_SET_STATUS_FALSY_LINK_ID,
                );
            }
        }).then(() => {
            const url = `/collaboration/groups/links/status/${linkId}?status=${status}`;
            return bop.put(url)
                .after({ statusCode: 202 })
                .run();
        }).catch((error) => {
            if (!error.code) {
                error.code = ShareableLinkErrors.SHAREABLE_LINK_SET_STATUS_UNEXPECTED_ERROR;
                error.details = { payload: JSON.stringify(payload) };
            }

            throw error;
        });
}
